module.exports = __webpack_public_path__ + "assets/img/00144.8c6311ac.png";